import { IconEdit, IconPhoto, IconX } from "@tabler/icons-react";
import type { PptxExportMode, PptxExportProgress } from "./pptx-export";

export function PptxExportChoiceDialog({
  busy,
  error,
  onClose,
  onChoose,
  progress,
  selectedMode,
  allowedModes,
}: {
  busy: boolean;
  error?: string;
  onClose: () => void;
  onChoose: (mode: PptxExportMode) => void;
  progress?: PptxExportProgress;
  selectedMode?: PptxExportMode;
  allowedModes: readonly PptxExportMode[];
}) {
  const editableOnly = allowedModes.length === 1 && allowedModes[0] === "editable";
  return <div className="pptx-export-overlay" role="dialog" aria-modal="true" aria-label="选择 PPTX 导出方式">
    <section className="pptx-export-dialog">
      <button className="pptx-export-close" type="button" aria-label="关闭" disabled={busy} onClick={onClose}><IconX size={20}/></button>
      <h2>选择导出方式</h2>
      <p>{editableOnly ? "导出可编辑 PPT，文字和基础图形可在 PowerPoint 中继续编辑。" : "两种版本会分别保存，可以按当前使用场景选择。"}</p>
      {editableOnly && <p>导出的 PPT 将写入 AI 生成说明和 AIGC 文件元数据。</p>}
      <div className={`pptx-export-options${allowedModes.length === 1 ? " single-option" : ""}`}>
        {allowedModes.includes("image") && <button type="button" data-export-mode="image" className={selectedMode === "image" ? "selected" : ""} aria-pressed={selectedMode === "image"} disabled={busy} onClick={() => onChoose("image")}>
          <i><IconPhoto size={24}/></i>
          <span><strong>高还原度图片 PPT</strong><small>视觉效果与在线预览最接近，页面内容整体为高清图片，不支持逐元素编辑。</small></span>
          <b>还原度优先</b>
        </button>}
        {allowedModes.includes("editable") && <button type="button" data-export-mode="editable" className={selectedMode === "editable" ? "selected" : ""} aria-pressed={selectedMode === "editable"} disabled={busy} onClick={() => onChoose("editable")}>
          <i><IconEdit size={24}/></i>
          <span><strong>可编辑 PPT</strong><small>文字和基础图形可在 PowerPoint 中编辑；复杂背景和特效可能转为图片。</small></span>
          <b>编辑优先</b>
        </button>}
      </div>
      {busy && <div className="pptx-export-working" aria-live="polite">
        <i/>
        <span><strong>{progress?.message || "正在准备导出…"}</strong><small>任务会在后台继续执行，请保持当前页面打开以便自动下载。</small></span>
        {typeof progress?.percent === "number" && <b>{progress.percent}%</b>}
        <em><u style={{ width: `${Math.max(2, Math.min(100, progress?.percent || 2))}%` }}/></em>
      </div>}
      {!busy && error && <div className="pptx-export-error" role="alert"><strong>导出失败</strong><span>{error}</span><small>{editableOnly ? "请重试导出可编辑 PPT。" : "可以重新选择一种导出方式再试。"}</small></div>}
    </section>
  </div>;
}
